/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetPrinterTokenDto
 */
export interface SetPrinterTokenDto {
    /**
     * 
     * @type {string}
     * @memberof SetPrinterTokenDto
     */
    url: string;
    /**
     * clientId, który obecnie posiada blokadę
     * @type {string}
     * @memberof SetPrinterTokenDto
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof SetPrinterTokenDto
     */
    token: string;
    /**
     * Znacznik czasu wygaśnięcia w formacie ISO
     * @type {string}
     * @memberof SetPrinterTokenDto
     */
    expiresAt: string;
}

/**
 * Check if a given object implements the SetPrinterTokenDto interface.
 */
export function instanceOfSetPrinterTokenDto(value: object): value is SetPrinterTokenDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    return true;
}

export function SetPrinterTokenDtoFromJSON(json: any): SetPrinterTokenDto {
    return SetPrinterTokenDtoFromJSONTyped(json, false);
}

export function SetPrinterTokenDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetPrinterTokenDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'clientId': json['clientId'],
        'token': json['token'],
        'expiresAt': json['expiresAt'],
    };
}

export function SetPrinterTokenDtoToJSON(value?: SetPrinterTokenDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'url': value['url'],
        'clientId': value['clientId'],
        'token': value['token'],
        'expiresAt': value['expiresAt'],
    };
}

